"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var stateTypes = _interopRequireWildcard(require("../../constants/state.types"));

var uiConstants = _interopRequireWildcard(require("../../constants/ui.constants"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getTextModifiers(_ref) {
  var truncated = _ref.truncated,
      truncatedCell = _ref.truncatedCell,
      forceLineBreak = _ref.forceLineBreak,
      microcopy = _ref.microcopy,
      fontSmall = _ref.fontSmall;
  return {
    'co--truncate': truncated,
    'co--truncate-cell': truncatedCell,
    'co--force-break': forceLineBreak,
    'co--microcopy': microcopy,
    'co--font-small': fontSmall
  };
}

function getAlignmentModifiers(_ref2) {
  var alignLeft = _ref2.alignLeft,
      alignCenter = _ref2.alignCenter,
      alignRight = _ref2.alignRight,
      alignment = _ref2.alignment;
  return {
    'co--align-left': alignLeft || alignment === 'left',
    'co--align-center': alignCenter || alignment === 'center',
    'co--align-right': alignRight || alignment === 'right'
  };
}

function getVerticalAlignmentModifiers(_ref3) {
  var alignTop = _ref3.alignTop,
      alignVerticalCenter = _ref3.alignVerticalCenter,
      alignBottom = _ref3.alignBottom;
  return {
    'co--valign-top': alignTop,
    'co--valign-center': alignVerticalCenter,
    'co--valign-bottom': alignBottom
  };
}

function getPositionModifiers(_ref4) {
  var pushLeft = _ref4.pushLeft,
      pushRight = _ref4.pushRight,
      pushTop = _ref4.pushTop,
      pushCenter = _ref4.pushCenter,
      pushVcenter = _ref4.pushVcenter,
      pushHcenter = _ref4.pushHcenter,
      pushBottom = _ref4.pushBottom,
      leftSpace = _ref4.leftSpace;
  return {
    'co--push-left': pushLeft,
    'co--push-right': pushRight,
    'co--push-center': pushCenter,
    'co--push-v-center': pushVcenter,
    'co--push-h-center': pushHcenter,
    'co--push-top': pushTop,
    'co--push-bottom': pushBottom
  };
}

function getSizeModifiers(_ref5) {
  var size = _ref5.size,
      tiny = _ref5.tiny,
      small = _ref5.small,
      medium = _ref5.medium,
      large = _ref5.large,
      xlarge = _ref5.xlarge,
      fullWidth = _ref5.fullWidth,
      fullHeight = _ref5.fullHeight;
  return {
    'co--tiny': tiny || size === uiConstants.SIZE_TINY,
    'co--small': small || size === uiConstants.SIZE_SMALL,
    'co--medium': medium || size === uiConstants.SIZE_MEDIUM,
    'co--large': large || size === uiConstants.SIZE_LARGE,
    'co--xlarge': xlarge || size === uiConstants.SIZE_XLARGE,
    'co--full-width': fullWidth,
    'co--full-height': fullHeight
  };
}

function getBorderModifiers(_ref6) {
  var borderless = _ref6.borderless,
      borderTop = _ref6.borderTop,
      borderBottom = _ref6.borderBottom;
  return {
    'co--borderless': borderless,
    'co--border-top': borderTop,
    'co--border-bottom': borderBottom
  };
}

function getLoadingStateModifiers(_ref7) {
  var loadingState = _ref7.loadingState;
  return {
    'co--errormark': loadingState === stateTypes.ERROR,
    'co--checkmark': loadingState === stateTypes.SUCCESS,
    'co--loading': loadingState === stateTypes.LOADING,
    'co--inline-loading': loadingState === stateTypes.INLINE_LOADING
  };
}

function getModifiers(props) {
  return _objectSpread({
    'co--disabled': props.disabled,
    'co--expanded': props.expanded,
    'co--success': props.success,
    'co--error': props.error,
    'co--danger': props.danger,
    'co--primary': props.primary,
    'co--secondary': props.secondary,
    'co--info': props.info,
    'co--warning': props.warning,
    'co--feature': props.feature,
    'co--active': props.active,
    'co--invert': props.inverted,
    'co--transition': props.transition,
    'co--transparent': props.transparent,
    'co--no-padding': props.noPadding,
    'co--light': props.light,
    'co--inline-flex': props.inline,
    'co--full-width': props.fullWidth,
    'co--focus': props.focused
  }, getTextModifiers(props), {}, getAlignmentModifiers(props), {}, getVerticalAlignmentModifiers(props), {}, getPositionModifiers(props), {}, getSizeModifiers(props), {}, getBorderModifiers(props), {}, getLoadingStateModifiers(props));
}

var Styler = function Styler(_ref8) {
  var children = _ref8.children,
      className = _ref8.className,
      classNames = _ref8.classNames,
      _ref8$modifiers = _ref8.modifiers,
      modifiers = _ref8$modifiers === void 0 ? {} : _ref8$modifiers;
  var styles = (0, _classnames.default)(classNames || className, getModifiers(modifiers)).trim();
  return children(styles || undefined);
};

Styler.propTypes = {
  children: _propTypes.func.isRequired,
  className: _propTypes.string,
  classNames: (0, _airbnbPropTypes.or)([_propTypes.array, _propTypes.object, _propTypes.string]),
  modifiers: _propTypes.object
};
var _default = Styler;
exports.default = _default;